import { useState, useContext } from 'react';
import Modal from "react-modal";
import { IoMdClose } from 'react-icons/io';
import { exportFileFrontEndGTIN,exportFileTest } from '../../services/exportFileFrontEndGTIN';
import { LoginContext } from '../../contexts/login_context';
import {showError, showWait, dismissToast, showSucess} from '../../services/toast';
import { exportFileTestGln } from '../../services/exportFileFrontEndGLN';
import { useSelector } from '../../native-state.dev';
import { exportFileTestOtherKey } from '../../services/exportFileFrontEndOtherKeys';
import { exportFileTestVerifyCompany } from '../../services/exportFileFrontEndVerifyCompany';
import { buildVerifyCompanyNcmRows } from '../../services/exportFileFrontEndVerifyCompanyNcm';
import { exportFileTestSimilaridade } from '../../services/exportFileFrontEndSimilaridade';

const ExportDetail = ({dataPrepared, itemType, className, chave}:{dataPrepared: any, itemType: string, className?: string, chave?: string}) => 
{
  
  const [stateModal, setStateModal] = useState(false);
  const [extension, setExtension] = useState('');
  const [stars, setStars] = useState(0)
  const [isOpenModalContestation, setIsOpenModalContestation] = useState(false);
  const [isOpenModalFaq, setIsOpenModalFaq] = useState(false);
  const { jwt } = useContext(LoginContext);

  const containerClass = className ? className : "printdata";

  const handleChange = (event:any) => 
  {
    setExtension(event.target.value)
  }


  const open = () => 
  {
    setExportButtonStatus(false);
    setStateModal(true)
    setExtension('')
  }

  const close = () =>
  {
    setStateModal(false)
  }
  const [modalObje,setState] = useSelector((s: { searchDone: any; })=>s.searchDone);

  const [exportButtonStatus, setExportButtonStatus] = useState(false);
  const exportFiles = async () =>
  {
    setExportButtonStatus(true);
    
    if(extension !== '')
    {
      setState({searchDone:false});

      let toastId = showWait('Aguarde, download em andamento.');

      if (itemType == "VERIFY_NCM") {
        const rows = buildVerifyCompanyNcmRows(dataPrepared);
        exportFileTest(rows, extension);
      }

      if (itemType === "REL_GTIN") {
        const normalizedKey = (chave || "").toUpperCase().trim();

        const rows = (Array.isArray(dataPrepared) ? dataPrepared : []).map((row: any) => {
          if (normalizedKey === "GTIN_KIT") {
            return {
              "GTIN Kit": row.gtinConsultado ?? "",
              "Descrição GTIN Kit": row.descricaoConsultado ?? "",
              "GTIN Contido": row.gtinRelacionado ?? "",
              "Descrição GTIN Contido": row.descricaoRelacionado ?? "",
            };
          }

          return {
            "GTIN": row.gtinConsultado ?? "",
            "Descrição GTIN": row.descricaoConsultado ?? "",
            "GTIN Origem": row.gtinRelacionado ?? "",
            "Descrição GTIN Origem": row.descricaoRelacionado ?? "",
          };
        });

        exportFileTest(rows, extension);
      }

      if(itemType=="GTIN")
        exportFileTest([exportFileFrontEndGTIN(dataPrepared)], extension);
      if(itemType=="GLN")
        exportFileTestGln([dataPrepared], extension,0);
      if(itemType=="OTHER_KEY")
        exportFileTestOtherKey([dataPrepared], extension,0);
      if(itemType=="VERIFY_COMPANY")
        exportFileTestVerifyCompany([dataPrepared], extension,0);
      if(itemType === "SIMILARIDADE")
        exportFileTestSimilaridade(dataPrepared, extension);
      
  
      
      setStateModal(false);
      dismissToast(toastId);
    }
    else
    {
      showError("Por favor, escolha uma extensão");
    }
    setExportButtonStatus(false);
  }
  return (
    <>
      <div className={`row ${containerClass} mt-5`}>

        <button
          onClick={() => window.print()}
          style={{
            marginRight:"15px",
          }}
        >
          Imprimir
        </button>
        <button
          name='buttonExport'
          onClick={() => open()}
          style={{
            marginRight:"2rem",
          }}
        >
          Exportar
        </button>

      </div>
      

      <Modal
        isOpen={stateModal}
        onRequestClose={close}
        ariaHideApp={false}
        contentLabel="Selected Option"
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex:1000,
            backgroundColor: "#262626CC",
          },
          content: {
            width: "370px",
            height: "330px",
            marginTop: "10%",
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            zIndex:1000,
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "4px",
            outline: "none",
            padding: "20px",
          },
        }}
      >
          <div style={{ padding: "0.5rem" }}>
            <span
              onClick={() => close()}
              style={{ position: "absolute", right: "7px", top: "7px" }}
            >
              <IoMdClose />
            </span>
            <div
              style={{ display: "flex", flexDirection: "column", rowGap: "2rem" }}
            >
              <span
                style={{
                  color: "#002C6C",
                  fontSize: "1.375rem",
                  marginBottom: "-25px",
                }}
              >
                Exportar Arquivo
              </span>
              <span
              style={{
                color: "#002C6C",
                fontSize: "13px",
                marginBottom: "-5px",
                fontWeight: "400"
              }}>
                Escolha o formato de arquivo para exportar
              </span>
              <span
                style={{
                  fontSize: "13px",
                  marginBottom: "-20px"
                }}
              >
              Formatos de arquivos
              </span>
              <span
                style={{
                  fontSize: "14px",
                  display: "felx",
                  flexDirection: "column"
                }}
              >
                <div>
                  <div style={{
                        display:"flex",
                        justifyContent:"left",
                        alignItems: "center",
                        marginBottom: "5px"
                      }}>
                    <input
                      type="radio"
                      value="txt"
                      name="extension"
                      checked={extension === 'txt'}
                      onChange={handleChange}
                      
                    /> &nbsp; .txt
                  </div>
                  <div style={{
                        display:"flex",
                        justifyContent:"left",
                        alignItems: "center",
                        marginBottom: "5px"
                      }}>
                    <input
                      type="radio"
                      value="xls"
                      name="extension"
                      checked={extension === 'xls'}
                      onChange={handleChange}
                    /> &nbsp; .xls
                  </div>
                  <div style={{
                        display:"flex",
                        justifyContent:"left",
                        alignItems: "center",
                        marginBottom: "5px"
                      }}>
                    <input
                      type="radio"
                      value="csv"
                      name="extension"
                      checked={extension === 'csv'}
                      onChange={handleChange}
                    /> &nbsp; .csv
                  </div>
                </div>
              </span>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  gap:10,
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >

                <button disabled={exportButtonStatus} onClick={() => exportFiles()} className="btn btn-primary btn-sm">
                    Exportar
                </button>
                <button disabled={exportButtonStatus} onClick={() => close()} className="btn btn-outline-primary btn-sm">
                  Cancelar
                </button>

              </div>
            </div>
          </div>

      </Modal> 


      

    </>
  )
};

export default ExportDetail;
